import { lazy, Suspense } from "react";
import SEOHead from "@/components/SEOHead";
import HeroSection from "@/components/HeroSection";

const LiveDropSection = lazy(() => import("@/components/home/LiveDropSection"));
const ShopByFranchise = lazy(() => import("@/components/home/ShopByFranchise"));
const FeaturedProducts = lazy(() => import("@/components/FeaturedProducts"));
const CreatorSpotlights = lazy(() => import("@/components/home/CreatorSpotlights"));
const DealCarousel = lazy(() => import("@/components/DealCarousel"));
const TopSellers = lazy(() => import("@/components/TopSellers"));
const AIRecommendations = lazy(() => import("@/components/AIRecommendations"));
const MarketingBanner = lazy(() => import("@/components/MarketingBanner"));
const LimitedDropBanner = lazy(() => import("@/components/LimitedDropBanner"));
const ReviewsSection = lazy(() => import("@/components/ReviewsSection"));
const Newsletter = lazy(() => import("@/components/Newsletter"));

const Fallback = () => <div className="min-h-[200px]" />;

const Index = () => {
  const homepageJsonLd = [
    {
      "@type": "WebPage",
      "name": "Grovefan — Gaming Gear, Merch & Collectibles",
      "description": "Shop India's gamer-first marketplace. Mice, keyboards, headsets, capture cards, esports merch, figurines & collectibles. Free shipping above ₹999.",
      "url": "https://grovefan.lovable.app/",
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://grovefan.lovable.app/" },
      ],
    },
    {
      "@type": "Store",
      "name": "Grovefan",
      "url": "https://grovefan.lovable.app",
      "priceRange": "₹₹",
      "description": "India's gamer-first marketplace — peripherals, audio, setup gear, merch & collectibles. Free shipping above ₹999.",
      "paymentAccepted": "UPI, Credit Card, Debit Card, Net Banking, Cash on Delivery",
      "currenciesAccepted": "INR",
    },
  ];

    const sections = [
      TopSellers,
      LiveDropSection,
      ShopByFranchise,
      FeaturedProducts,
      CreatorSpotlights,
      DealCarousel,
      AIRecommendations,
      MarketingBanner,
      LimitedDropBanner,
      ReviewsSection,
      Newsletter,
    ];

  return (
    <div className="relative">
      <SEOHead canonical="/" jsonLd={homepageJsonLd} />
      <HeroSection />
      <div className="relative cv-auto">

        {sections.map((Section, i) => (
          <Suspense key={i} fallback={<Fallback />}>
            <Section />
          </Suspense>
        ))}
      </div>
    </div>
  );
};

export default Index;
